export class GcpCloudSqlSnapshotProperties {
    'instanceId';
    'region';
    'zone';
    'databaseVersion';
    'network';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "instanceId",
            "baseName": "instanceId",
            "type": "string",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "zone",
            "baseName": "zone",
            "type": "string",
            "format": ""
        },
        {
            "name": "databaseVersion",
            "baseName": "databaseVersion",
            "type": "string",
            "format": ""
        },
        {
            "name": "network",
            "baseName": "network",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GcpCloudSqlSnapshotProperties.attributeTypeMap;
    }
    constructor() {
    }
}
